import { ChevronLeft, ChevronRight } from "lucide-react";

export function DataTable({ testid, columns, rows, rowKey, onRowClick, empty }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto max-w-full">
      <table data-testid={testid} className="w-full text-sm min-w-[720px]">
        <thead>
          <tr className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            {columns.map((c) => <th key={c.key} className="px-4 py-3">{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr><td colSpan={columns.length} data-testid={`${testid}-empty`} className="px-4 py-10 text-center text-slate-400">{empty}</td></tr>
          )}
          {rows.map((row) => (
            <tr key={row[rowKey]} data-testid={`${testid}-row-${row[rowKey]}`} onClick={onRowClick ? () => onRowClick(row[rowKey]) : undefined}
              className={`border-t border-slate-100 ${onRowClick ? "hover:bg-slate-50 cursor-pointer" : ""} transition-colors`}>
              {columns.map((c) => <td key={c.key} className="px-4 py-3">{c.render ? c.render(row) : (row[c.key] ?? "") === "" ? "—" : row[c.key]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function Pager({ testid, page, pages, total, onPage }) {
  return (
    <div className="flex items-center justify-between text-sm text-slate-600">
      <span data-testid={`${testid}-total`}>{total} résultat(s)</span>
      <div className="flex items-center gap-2">
        <button data-testid={`${testid}-prev`} onClick={() => onPage(page - 1)} disabled={page <= 1}
          className="p-1.5 rounded-lg border border-slate-200 disabled:opacity-40 hover:bg-slate-50"><ChevronLeft className="w-4 h-4" /></button>
        <span className="text-xs">{page} / {pages}</span>
        <button data-testid={`${testid}-next`} onClick={() => onPage(page + 1)} disabled={page >= pages}
          className="p-1.5 rounded-lg border border-slate-200 disabled:opacity-40 hover:bg-slate-50"><ChevronRight className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
